import {headers} from '../common'

async function resetAccount(mailAddress, loginId, type) {
  return fetch('/api/reset-account', {
    method: 'POST',
    headers: headers,
    body: JSON.stringify({ mail_address: mailAddress, login_id: loginId, type: type }),
  }).then(res => {
    return res;
  })
  .catch(errors => {
    return errors;
  })
}

export { resetAccount }
